<app-programtitle title="Count the frequency of words "></app-programtitle>

<p> Write a progrm to count the frequency of words in a given sentence.</p>
<app-editor code="{{program}}"> </app-editor>